"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _preact = require("preact");

var _TranslationForm = _interopRequireDefault(require("./TranslationForm"));

var exp = function exp(options) {
  (0, _preact.render)((0, _preact.h)(_TranslationForm.default, options), document.querySelector(options.el));
};

module.exports = exp;